import { type ReactNode, useEffect } from 'react';

import { identifyUser, initPostHog, resetIdentity } from '@/lib/analytics/posthog';

import { useAuth } from './auth-provider';

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    initPostHog();
  }, []);

  const { user } = useAuth();
  useEffect(() => {
    // `role` is null when the backend sent a token this build doesn't know (see `roleSchema`);
    // send an explicit marker rather than a null so drifted sessions stay segmentable in PostHog.
    if (user) identifyUser(user.id, { role: user.role ?? 'unknown' });
    else resetIdentity();
  }, [user]);

  return <>{children}</>;
}
